videojs.addLanguage('en', {
	"Episode": "Episode"
});
